module.exports = __webpack_public_path__ + "static/img/xccy_bg.e87e81d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/xccy_bg.png
// module id = gryw
// module chunks = 1